import { Fragment, useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { Cities } from "../../utils/helpers/cities";
import { DebounceHook } from "../hooks/DebounceHook";
import { Loading } from "../../utils/helpers/constants";
import BookingService from "../../utils/services/booking.service";
import { formatAddress } from "../../utils/helpers/logicHelper";

const MapsSelectHook = ({ label, placeholder, className, setInitialValue, setLocation, setError, value, onInputChange }) => {
	const [mapOptions, setMapOptions] = useState([]);
	const [debounceField, setDebounceField] = useState("");
	const [locationObject, setLocationObject] = useState({});
	const [debounceState, setDebounceState] = useState(false);
	const [mapOptionsState, setMapOptionsState] = useState(false);
	const debounceText = DebounceHook(debounceField, 350);

	useEffect(() => {
		if (Object.entries(locationObject).length > 0) callPlacesAPI(locationObject['place_id']).catch(err => console.trace(err));
	}, [locationObject]);

	useEffect(() => {
		if (debounceText && debounceState) callAutoCompleteAPI(debounceText).catch(err => console.trace(err));
	}, [debounceText]);
	// const getDebounceField = () => {
	// 	if (debounceField) return debounceField;
	// 	else if (setInitialValue) return setInitialValue;
	// 	else return debounceField;
	// }

	useEffect(() => { setDebounceField(formatAddress(setInitialValue) || ""); }, [setInitialValue]);

	const updateDebounceField = value => {
		setDebounceField(value);
		onInputChange?.(value);
		setDebounceState(true);
		 if (value === "") setLocation?.({address: ""});
	}

	const selectMapOption = item => {
		setMapOptionsState(false);
		setDebounceField(formatAddress(item.name));
		setLocationObject(item);
	}

	const callAutoCompleteAPI = async data => {
		const { data: responseData } = await BookingService.autoCompleteMapsBySearch(data);
		if (responseData.status !== Loading.SUCCESS) setError(responseData.status);
		else {
			setDebounceState(false);
			setMapOptionsState(true);
			setMapOptions(responseData.data);
		}
	}

	const callPlacesAPI = async data => {
		if (data) {
			const { data: responseData } = await BookingService.placesApiMap(data);
			if (responseData.status !== Loading.SUCCESS) setError(responseData.status);
			else {
				const addressComponents = responseData.data['address_components'] || [];
				const findComponent = type => addressComponents.find(component => component.types?.includes(type));
				const cityComponent = findComponent("locality")
					|| findComponent("postal_town")
					|| findComponent("administrative_area_level_2")
					|| findComponent("sublocality")
					|| findComponent("sublocality_level_1");
				const stateComponent = findComponent("administrative_area_level_1");
				const rawCity = cityComponent?.long_name || cityComponent?.short_name || "";
				const rawState = stateComponent?.long_name || stateComponent?.short_name || "";
				const matchedCity = Cities.find(eachCity => rawCity && eachCity.city.toLowerCase() === rawCity.toLowerCase());

				const parseAddressFallback = (address = "") => {
					const parts = address.split(",").map(part => part.trim()).filter(Boolean);
					if (parts.length === 0) return { city: "", state: "" };
					if (parts.length === 1) return { city: parts[0], state: parts[0] };
					const country = parts[parts.length - 1];
					const hasCountry = country.toLowerCase() === "nigeria";
					const state = hasCountry ? parts[parts.length - 2] : parts[parts.length - 1];
					const city = hasCountry
						? (parts.length >= 3 ? parts[parts.length - 3] : state)
						: (parts.length >= 2 ? parts[parts.length - 2] : state);
					return { city, state };
				};

				const fallback = parseAddressFallback(responseData.data.address);
				const resolvedCity = matchedCity ? matchedCity.city : (rawCity || fallback.city);
				const resolvedState = matchedCity ? matchedCity.state : (rawState || fallback.state);
				let city = resolvedCity ? resolvedCity.toUpperCase() : "DEFAULT";
				let state = resolvedState || "DEFAULT";
				let placeData = {
					city, state, address: responseData.data.address,
					latitude: responseData.data['geometry']['latitude'],
					longitude: responseData.data['geometry']['longitude']
				};
				setLocation(placeData)
			}
		} else return toast.error("We are unable to resove this location, Please select another location that is approximately close to your choice of location");
	}

	const displayValue = useMemo(() => {
		if (value !== undefined) {
			return value === setInitialValue ? formatAddress(value) : value;
		}
		return debounceField;
	}, [value, debounceField, setInitialValue]);



	return (
		<Fragment>
			<div style={{ position: "relative", width: "100%" }}>
				{label && <label className="mb-3">{label}</label>}
				<input type="text" placeholder={placeholder} value={displayValue}
					onChange={e => updateDebounceField(e.target.value)} className={className} />
				{mapOptionsState && <div className="booking-form-dropdown p-3">
					{mapOptions.slice(0, 5).map((item, index) =>
						<div key={index} onClick={() => selectMapOption(item)} className="item py-3 pointer-event">
							<span>{item.name}</span>
						</div>
					)}
				</div>
				}
			</div>
		</Fragment>

	)
}

export default MapsSelectHook

